import React from 'react';
import { motion } from 'framer-motion';
import { XCircle, Brain, Settings, Heart } from 'lucide-react';
export function WhyItHappensSection() {
  return <section className="py-10 bg-stone-50" data-id="element-342">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-343">
        <div className="text-center mb-10" data-id="element-344">
          <h2 className="text-3xl md:text-4xl font-extrabold text-stone-900 mb-4" data-id="element-345">
            El error #1 que dispara el caos diario
          </h2>
          <p className="text-xl text-stone-600 mb-8" data-id="element-346">
            Casi todos los padres cometen el mismo error sin darse cuenta:
          </p>
          <div className="inline-block bg-white px-8 py-4 rounded-2xl shadow-sm border border-stone-200 transform -rotate-1" data-id="element-347">
            <span className="text-4xl md:text-5xl font-black text-amber-500 tracking-tight" data-id="element-348">
              Piden sin mostrar.
            </span>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 lg:gap-10 max-w-5xl mx-auto mb-10" data-id="element-349">
          {/* Left Column: The Mistake */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-red-50 p-8 rounded-3xl border-l-8 border-red-400 shadow-sm" data-id="element-350">
            <h3 className="text-xl font-bold text-red-800 mb-6 uppercase tracking-wide" data-id="element-351">
              Lo que dices:
            </h3>
            <ul className="space-y-4 mb-8" data-id="element-352">
              <li className="flex items-start gap-3" data-id="element-353">
                <XCircle className="w-6 h-6 text-red-500 shrink-0 mt-1" data-id="element-354" />
                <span className="text-lg text-stone-700 font-medium italic" data-id="element-355">
                  «Primero los zapatos, después la mochila, luego la campera, y
                  apúrate...»
                </span>
              </li>
            </ul>
            <div className="bg-white/60 p-4 rounded-xl" data-id="element-356">
              <p className="text-stone-800 font-semibold" data-id="element-357">
                El resultado:{' '}
                <span className="font-normal text-stone-600" data-id="element-358">
                  El niño se queda quieto. Se distrae. Se frustra. Explota.
                </span>
              </p>
            </div>
          </motion.div>

          {/* Right Column: The Reason */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-blue-50 p-8 rounded-3xl border-l-8 border-blue-400 shadow-sm" data-id="element-359">
            <h3 className="text-xl font-bold text-blue-800 mb-6 uppercase tracking-wide" data-id="element-360">
              Por qué pasa:
            </h3>
            <p className="text-stone-700 mb-4" data-id="element-361">
              El cerebro infantil todavía está desarrollando su equipo interno:
            </p>
            <ul className="space-y-3 mb-6" data-id="element-362">
              <li className="flex items-center gap-3 text-stone-700 font-medium" data-id="element-363">
                <Brain className="w-5 h-5 text-blue-500" data-id="element-364" />
                Memoria de trabajo
              </li>
              <li className="flex items-center gap-3 text-stone-700 font-medium" data-id="element-365">
                <Settings className="w-5 h-5 text-blue-500" data-id="element-366" />
                Función ejecutiva
              </li>
              <li className="flex items-center gap-3 text-stone-700 font-medium" data-id="element-367">
                <Heart className="w-5 h-5 text-blue-500" data-id="element-368" />
                Autorregulación
              </li>
            </ul>
            <div className="bg-white/60 p-4 rounded-xl" data-id="element-369">
              <p className="text-stone-800 font-semibold italic" data-id="element-370">
                En momentos de estrés, las palabras se evaporan. Las imágenes se
                quedan.
              </p>
            </div>
          </motion.div>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-emerald-500 text-white rounded-3xl p-8 md:p-12 text-center max-w-4xl mx-auto shadow-xl" data-id="element-371">
          <p className="text-2xl md:text-3xl mb-2 opacity-90" data-id="element-372">
            La solución no es hablar más.
          </p>
          <p className="text-3xl md:text-4xl font-black tracking-tight" data-id="element-373">
            La solución es mostrar mejor.
          </p>
        </motion.div>
      </div>
    </section>;
}